import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const addonsReducer = (state = initialState.addons, action) => {
  switch (action.type) {
    case types.GET_ADDONS_SUCESS:
      return action.payload;

    case types.GET_ADDONS_FAIL:
      return initialState.addons;

    default:
      return state;
  }
};

export const addonImagesLookupTableReducer = (
  state = initialState.addonImagesLookupTable,
  action
) => {
  switch (action.type) {
    case types.GET_ADDONS_IMAGES_SUCESS:
      return action.payload;

    case types.GET_ADDONS_FAIL:
      return initialState.addonImagesLookupTable;

    default:
      return state;
  }
};

const selectedAddonReducer = (state = 0, action) => {
  switch (action.type) {
    case types.ADDON_ADDED:
      return state + 1;

    case types.ADDON_REMOVED:
      return state > 0 ? state - 1 : 0;

    default:
      return state;
  }
};

const selectedAddonsReducer = (state = {}, action) => {
  switch (action.type) {
    case types.ADDON_ADDED:
    case types.ADDON_REMOVED: {
      const currentValue = state[action.payload.addonCode];
      return {
        ...state,
        [action.payload.addonCode]: selectedAddonReducer(currentValue, action)
      };
    }
    case types.ADDONS_CANCELED:
      return {};

    default:
      return state;
  }
};

export const selectedAddonsGroupReducer = (
  state = initialState.selectedAddonsGroup,
  action
) => {
  switch (action.type) {
    case types.ADDON_ADDED:
    case types.ADDON_REMOVED:
    case types.ADDONS_CANCELED: {
      const nextstate = {
        ...state,
        [action.payload.groupId]: selectedAddonsReducer(
          state[action.payload.groupId],
          action
        )
      };
      return nextstate;
    }

    default:
      return state;
  }
};

export const addonsForOrderReducer = (state = [], action) => {
  switch (action.type) {
    case types.SET_ADDONS_FOR_ORDER:
      return action.payload || state;
    default:
      return state;
  }
};

export const addonsCurosselRoomNumberReducer = (state = 0, action) => {
  switch (action.type) {
    case types.SET_ADDONS_CUROSSEL_ROOM_NUMBER:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/addonsReducer.js